/*eslint-disable*/
import React from 'react';
import AddNetwork from './Children/AddNetwork';
export const STEPS = [
  {
    id: 1,
    label: 'Networks',
    content: AddNetwork,
    icon: (
      <svg
        id='Group_16166'
        data-name='Group 16166'
        xmlns='http://www.w3.org/2000/svg'
        xmlnsXlink='http://www.w3.org/1999/xlink'
        width='20.736'
        height='20.19'
        viewBox='0 0 20.736 20.19'>
        <defs>
          <clipPath id='clip-path'>
            <rect
              id='Rectangle_17811'
              data-name='Rectangle 17811'
              width='20.736'
              height='20.19'
              fill='#397aa3'
            />
          </clipPath>
        </defs>
        <g id='Group_16165' data-name='Group 16165' clip-path='url(#clip-path)'>
          <path
            id='Path_127'
            data-name='Path 127'
            d='M14.392,16.586c-.243,0-.387.181-.39.5,0,.495,0,.99,0,1.485,0,.586-.236.824-.819.824q-5.793,0-11.585,0c-.558,0-.8-.236-.8-.786q0-7.887,0-15.774c0-.532.249-.776.782-.779.619,0,1.237,0,1.856,0,.076,0,.153.012.243.019,0,.27,0,.517,0,.764.005.31.145.462.452.462q3.261.005,6.522,0c.321,0,.457-.15.461-.48,0-.245,0-.49,0-.744.805,0,1.58-.016,2.354.008a.57.57,0,0,1,.513.53,2.436,2.436,0,0,1,.02.37Q14,6.242,14,9.5c0,.33.132.491.385.5s.407-.161.407-.478c0-2.262.011-4.525,0-6.787a1.44,1.44,0,0,0-1.507-1.477c-.618-.008-1.237,0-1.856,0h-.267c-.024-.048-.039-.063-.039-.079,0-.23,0-.459-.008-.689C11.109.139,10.983.006,10.636,0,10.212,0,9.788,0,9.363,0H4.353c-.6,0-.675.071-.675.663v.592c-.735,0-1.433,0-2.13,0A1.449,1.449,0,0,0,0,2.776Q0,10.716,0,18.656a1.431,1.431,0,0,0,1.5,1.527q5.885.012,11.771,0a1.439,1.439,0,0,0,1.515-1.494c.014-.539.006-1.078,0-1.617,0-.309-.16-.49-.4-.487M4.484.815H10.3V2.485H4.484ZM20.5,7.047a1.368,1.368,0,0,0,.054-1.46A1.372,1.372,0,0,0,19.3,4.825a1.476,1.476,0,0,0-1.3.727q-3.109,4.516-6.233,9.022a1.677,1.677,0,0,0-.315,1.349,1.312,1.312,0,0,1-.289,1.4.082.082,0,0,0-.013.023.391.391,0,0,0,.117.537.375.375,0,0,0,.523-.079,2.36,2.36,0,0,0,.262-.365.583.583,0,0,1,.478-.311,2.435,2.435,0,0,0,1.844-1.167c1.161-1.772,2.394-3.5,3.6-5.24l.855-1.237.292.2c-.04.062-.067.107-.1.15Q18.01,11.3,17,12.776a.4.4,0,1,0,.648.454q1.179-1.7,2.347-3.4a.391.391,0,0,0-.112-.6c-.183-.137-.374-.263-.586-.411.064-.1.11-.171.16-.243.349-.51.71-1.012,1.045-1.531M18.838,8.064c-1.729,2.505-3.472,5-5.177,7.523a1.689,1.689,0,0,1-1.329.756,1.633,1.633,0,0,1,.2-1.49c1.769-2.51,3.5-5.046,5.246-7.573.049-.071.1-.139.165-.224l1.073.739c-.064.1-.121.182-.18.267M18.391,6.4a6.986,6.986,0,0,1,.42-.579.648.648,0,0,1,1.047.741c-.107.2-.247.381-.383.586L18.391,6.4m-6.569,7.428a.364.364,0,0,0,.313-.4.358.358,0,0,0-.344-.37,2.442,2.442,0,0,0-.291-.009H3.286a1.928,1.928,0,0,0-.317.014.35.35,0,0,0-.311.344.355.355,0,0,0,.266.405,1.13,1.13,0,0,0,.314.03q4.16,0,8.32,0a1.235,1.235,0,0,0,.263-.016m-8.8-5.057a2.188,2.188,0,0,0,.238,0h8.266a2.282,2.282,0,0,0,.238,0,.367.367,0,0,0,.366-.377.374.374,0,0,0-.338-.406,1.191,1.191,0,0,0-.238-.008H3.236A1.218,1.218,0,0,0,3,7.984a.374.374,0,0,0-.341.4.367.367,0,0,0,.364.38m-.075,2.52a1.049,1.049,0,0,0,.289.021h8.318a1.043,1.043,0,0,0,.288-.021.393.393,0,0,0-.051-.768,1.557,1.557,0,0,0-.238-.006H3.235A1.538,1.538,0,0,0,3,10.52a.393.393,0,0,0-.05.768M3.078,6.23a2.248,2.248,0,0,0,.291.01h8.055a2.151,2.151,0,0,0,.291-.01.389.389,0,0,0,.025-.768,1.258,1.258,0,0,0-.263-.016H3.316a1.267,1.267,0,0,0-.263.016.389.389,0,0,0,.025.768m4.738,9.344H3.767a6.7,6.7,0,0,0-.687.013.359.359,0,0,0-.344.4.368.368,0,0,0,.366.378,2.377,2.377,0,0,0,.238.006H7.362c.229,0,.459.006.688,0a.38.38,0,0,0,.409-.39.391.391,0,0,0-.405-.4c-.079-.007-.159,0-.238,0'
            transform='translate(0 0.001)'
            fill='#397aa3'
          />
        </g>
      </svg>
    ),
  },

];

export const PAGE_BREADCRUMB = (data, organisationName) => {
  return [
    { name: 'Networks', path: '/dashboard' },
    {
      name: organisationName,
      path: ``,
    },
  ];
};
